module.exports = __webpack_public_path__ + "static/media/hand-paper.d78ade25.svg";